module.exports = __webpack_public_path__ + "static/images/containers/WGCWXBattleSchedule/images/background_vehicles_dark.926914bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXBattleSchedule/images/background_vehicles_dark.jpg
// module id = 3451
// module chunks = 11